<template>
  <v-container fluid>
    <!-- <p>{{ AllCods }}</p> -->
    <v-card>
      <v-card-title dense class="error white--text">
        <v-toolbar-title v-if="fromDate && toDate"
          >Arrived: {{ fromDate }} --- {{ toDate }}</v-toolbar-title
        >

        <v-divider class="mx-4" inset vertical></v-divider>
        <!-- <div class="flex-grow-1"></div> -->
        <searchDate
          Thismonth
          :searching="isLoading"
          :SearchFun="OnSearch"
        ></searchDate>
      </v-card-title>
      <v-card-text>
        <v-data-table
          dense
          :loading="isLoading"
          :headers="headers"
          :items="Products"
        >
          <template #top>
            <v-toolbar color="grey lighten-3">
              <strong class="primary--text">
                T-COST:
                <span class="black--text">
                  {{ ReportSumary.cost.toLocaleString() }}
                </span>
              </strong>
              <v-spacer></v-spacer>
              <strong class="success--text">
                T-PRICE:
                <span class="black--text">
                  {{ ReportSumary.price.toLocaleString() }} (
                  {{ Tprofi.SProfit }}%)
                </span>
              </strong>
              <v-spacer></v-spacer>
              <strong>
                SALE:
                <span>
                  {{ ReportSumary.cashIN.toLocaleString() }}
                  ( {{ Tprofi.InProfit }}%)
                </span>
              </strong>
            </v-toolbar>
          </template>
          <template #[`item.CRT`]="{ item }">
            {{ item.CRT && item.CRT.toLocaleString() }}

            <span v-if="item.TOTALPCS" class="error--text">{{
              `(${item.TOTALPCS} PCS)`
            }}</span>
          </template>

          <template #[`item.qtyout`]="{ item }">
            {{ item.Stocks | QTYOUT }}

            <span class="error--text">{{ item.Stocks | PCSOUT }}</span>
          </template>

          <template #[`item.remailQty`]="{ item }">
            {{ item | RemainQTY }}

            <!-- <span class="error--text ">{{ item.Stocks | PCSOUT }}</span> -->
          </template>

          <template #[`item.cashin`]="{ item }">
            {{ item | CASHIN }}
          </template>
          <template #[`item.COST`]="{ item }">
            {{ item.COST && item.COST.toLocaleString() }}
          </template>
          <template #[`item.PRICE`]="{ item }">
            {{ item | profitPrice }}
          </template>
          <!-- <template #item.info="{ item }"> </template> -->
          <template #[`item.info`]="{ item }">
            <v-card flat class="d-flex justify-space-between align-center">
              <div class="mr-2">
                <base-edite-date
                  DetailsKey="DetailsOrder"
                  RefKey="code"
                  :Info="item"
                  BaseURL="/stock"
                  :FinishedWithdrow="
                    val => {
                      item.DetailsOrder = val;
                      return null;
                    }
                  "
                ></base-edite-date>
              </div>
              <!-- Arrave view Items -->
              <div class="ml-2">
                <tranView :key="item.code" :Order="item" />
              </div>
              <!-- Delete Arrived Items -->
              <div class="ml-2">
                <BaseDelete
                  :DelQuery="{ OrderCode: item.code }"
                  DelUrl="/stock/Remove"
                  :OnFinish="
                    () => {
                      Products = Products.filter(inv => inv.code != item.code);
                    }
                  "
                >
                  <template v-slot:title>
                    Order Code: {{ item.code }}
                  </template>
                  <template v-slot:DeleteBtn>
                    <v-btn icon color="error">
                      <v-icon small>fas fa-trash-alt</v-icon>
                    </v-btn>
                  </template>
                  <h3 class="text-center">
                    <div>Supplier: {{ item.CostName }}</div>
                    <div>QTY: {{ item.CRT && item.CRT.toLocaleString() }}</div>
                    <div>
                      Cost: {{ item.COST && item.COST.toLocaleString() }}
                    </div>
                  </h3>
                </BaseDelete>
              </div>
            </v-card>
          </template>
        </v-data-table>
      </v-card-text>
      <v-card-actions>
        <!-- <OnTheWay :OnFinish="OnTheWayLoad"></OnTheWay> -->
      </v-card-actions>
    </v-card>
  </v-container>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  components: {
    searchDate: () => import("@/components/util/searchDate.vue"),
    // OnTheWay: () => import("@/components/HQ/TheWay/items/BulkInventory"),
    tranView: () => import("@/components/HQ/TheWay/items/ariveDetails.vue"),
  },
  filters: {
    profitPrice({ COST, PRICE }) {
      let PROFIT = ((PRICE / COST - 1) * 100).toFixed(1);
      return PRICE.toLocaleString() + ` (${PROFIT}%)`;
    },
    QTYOUT(outArray) {
      return outArray.reduce((total, qty) => {
        return (total += parseInt(qty.QTYOUT));
      }, 0);
    },
    PCSOUT(outArray) {
      let TotalPcs = outArray.reduce((total, qty) => {
        let pcs = (qty.QTYOUT - parseInt(qty.QTYOUT)) * qty.UnitQty;
        return (total += pcs);
      }, 0);
      return Math.round(TotalPcs) ? `(${Math.round(TotalPcs)} PCS)` : "";
    },
    CASHIN({ Stocks, COST }) {
      let total = Stocks.reduce((total, qty) => {
        return (total += qty.CASHIN);
      }, 0);
      let precent = (total / COST) * 100;
      return `${total.toLocaleString()} (${precent.toFixed(2)}%)`;
    },
    RemainQTY({ CRT, Stocks }) {
      let outCRT = Stocks.reduce((total, qty) => {
        return (total -= parseInt(qty.QTYOUT));
      }, CRT);

      return outCRT.toLocaleString();
    },
    // RemainPCS({ CRT, TOTALPCS, Stocks }) {
    //   let outCRT = Stock.reduce((total, qty) => {
    //     return (total -= (qty.QTYOUT));
    //   }, CRT);
    //   let TotalPcs = Stocks.reduce((total, qty) => {
    //     let pcs = (qty.QTYOUT - parseInt(qty.QTYOUT)) * qty.UnitQty;
    //     return (total += pcs);
    //   }, 0);
    // }
  },
  data() {
    return {
      Stock: "/stock",
      fromDate: "",
      toDate: "",
      isLoading: false,
      Products: [],
      headers: [
        {
          text: "DATE",
          align: "left",
          value: "date",
          divider: true,
          class: "grey darken-3 white--text",
        },
        {
          text: "ORDER",
          align: "left",
          value: "code",
          divider: true,
          class: "grey darken-3 white--text",
        },
        // {
        //   text: "SUPPLIER",
        //   align: "left",
        //   value: "CostName",
        //   divider: true,
        //   class: "grey darken-3 white--text"
        // },

        {
          text: "QTY(IN)",
          value: "CRT",
          divider: true,
          class: "grey darken-3 white--text",
        },
        {
          text: "QTY(OUT)",
          value: "qtyout",
          divider: true,
          align: "start",
          class: "grey darken-3 white--text",
        },
        {
          text: "QTY(Remain)",
          value: "remailQty",
          divider: true,
          align: "start",
          class: "grey darken-3 white--text",
        },
        {
          text: "COST",
          value: "COST",
          divider: true,
          class: "grey darken-3 white--text",
        },
        {
          text: "PRICE",
          value: "PRICE",
          divider: true,
          align: "start",
          class: "grey darken-3 white--text",
        },

        {
          text: "CASH(IN)",
          value: "cashin",
          divider: true,
          align: "start",
          class: "grey darken-3 white--text",
        },

        {
          text: "INFO",
          value: "info",
          align: "start",
          class: "grey darken-3 white--text",
        },
      ],
    };
  },
  computed: {
    ...mapGetters(["getProducts"]),
    Tprofi() {
      return {
        SProfit: (
          (this.ReportSumary.price / this.ReportSumary.cost - 1) *
          100
        ).toFixed(1),
        InProfit: (
          (this.ReportSumary.cashIN / this.ReportSumary.cost) *
          100
        ).toFixed(1),
      };
    },
    ReportSumary() {
      return {
        cost: this.Products.reduce((total, item) => {
          return (total += item.COST);
        }, 0),
        price: this.Products.reduce((total, item) => {
          return (total += item.PRICE);
        }, 0),
        cashIN: this.Products.reduce((TCashIn, item) => {
          return (TCashIn += item.Stocks.reduce((total, qty) => {
            return (total += qty.CASHIN);
          }, 0));
        }, 0),
      };
    },
    AllCods() {
      return this.getProducts.reduce((codes, prod) => {
        let { price, cost } = codes[prod.code] || { price: 0, cost: 0 };
        codes[prod.code] = {
          cost: cost + prod.qty * prod.cost,
          price: price + prod.qty * prod.price,
        };
        return codes;
      }, {});
    },
  },
  methods: {
    OnSearch(from, to) {
      this.fromDate = from;
      this.toDate = to;

      this.sales = [];
      this.TotalBalance = [];

      this.OnTheWayLoad();
    },
    getReByQuery(value) {
      return this.$store.dispatch("FIND_BY_VALUE", value);
    },

    OnTheWayLoad(data = []) {
      if (data && data.length) {
        this.Products = data;
        return;
      }

      this.isLoading = true;
      this.getReByQuery({
        url: this.Stock,
        query: { from: this.fromDate, to: this.toDate },
      })
        .then(val => {
          // console.log(val.data);
          this.Products = val.data;
          this.isLoading = false;
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
  created() {
    // console.log(this.Current());
    const { Thismonth, date } = this.Current();
    this.fromDate = Thismonth;
    this.toDate = date;
    this.OnTheWayLoad([]);
    // if (!this.getProducts.length) this.$store.dispatch("LoadProdacts");
  },
};
</script>
